import React, { Component } from 'react';
import { DashboardCard } from './DashboardCard';
import { BarChart3Icon, TruckIcon, DollarSignIcon, ClipboardCheckIcon, BadgeIcon, ArrowUpIcon, ArrowDownIcon, TrendingUpIcon, MapIcon, GlobeIcon, UsersIcon, CheckCircleIcon, XCircleIcon, MoreHorizontalIcon } from 'lucide-react';
export function DashboardOverview() {
  return <div className="space-y-6" data-id="element-950">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-951">
        <StatCard title="Active Orders" value="22" trend="+4" trendLabel="from last month" trendUp={true} icon={<TruckIcon size={20} className="text-indigo-400" data-id="element-953" />} color="indigo" data-id="element-952" />
        <StatCard title="Total Quotes" value="2,392" trend="+152" trendLabel="from last month" trendUp={true} icon={<DollarSignIcon size={20} className="text-blue-400" data-id="element-955" />} color="blue" data-id="element-954" />
        <StatCard title="Warranty Claims" value="125" trend="-12" trendLabel="from last month" trendUp={false} icon={<ClipboardCheckIcon size={20} className="text-emerald-400" data-id="element-957" />} color="emerald" data-id="element-956" />
        <StatCard title="Active Subscriptions" value="991" trend="+38" trendLabel="from last month" trendUp={true} icon={<BadgeIcon size={20} className="text-violet-400" data-id="element-959" />} color="violet" data-id="element-958" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-960">
        <DashboardCard title="Regional Distribution" icon={<GlobeIcon size={20} className="text-blue-400" data-id="element-962" />} className="lg:col-span-2" data-id="element-961">
          <div className="h-80 relative" data-id="element-963">
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-964">
              <div className="grid grid-cols-2 gap-4 w-full max-w-2xl px-6" data-id="element-965">
                <RegionStat name="EUROPE" value="820" percentage={75} color="blue" data-id="element-966" />
                <RegionStat name="AMERICA" value="180" percentage={45} color="indigo" data-id="element-967" />
                <RegionStat name="MENA" value="10" percentage={15} color="emerald" data-id="element-968" />
                <RegionStat name="AFRICA" value="20" percentage={25} color="amber" data-id="element-969" />
                <RegionStat name="LATAM" value="160" percentage={40} color="rose" data-id="element-970" />
                <RegionStat name="ANZ" value="150" percentage={35} color="violet" data-id="element-971" />
              </div>
            </div>
          </div>
        </DashboardCard>
        <DashboardCard title="Performance Overview" icon={<BarChart3Icon size={20} className="text-blue-400" data-id="element-973" />} data-id="element-972">
          <div className="space-y-6" data-id="element-974">
            <div data-id="element-975">
              <div className="flex justify-between mb-2" data-id="element-976">
                <span className="text-sm text-blue-300" data-id="element-977">Orders Completion</span>
                <span className="text-sm font-medium text-white" data-id="element-978">78%</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-2" data-id="element-979">
                <div className="bg-indigo-500 h-2 rounded-full" style={{
                width: '78%'
              }} data-id="element-980"></div>
              </div>
            </div>
            <div data-id="element-981">
              <div className="flex justify-between mb-2" data-id="element-982">
                <span className="text-sm text-blue-300" data-id="element-983">Quote Conversion</span>
                <span className="text-sm font-medium text-white" data-id="element-984">42%</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-2" data-id="element-985">
                <div className="bg-blue-500 h-2 rounded-full" style={{
                width: '42%'
              }} data-id="element-986"></div>
              </div>
            </div>
            <div data-id="element-987">
              <div className="flex justify-between mb-2" data-id="element-988">
                <span className="text-sm text-blue-300" data-id="element-989">
                  Warranty Resolution
                </span>
                <span className="text-sm font-medium text-white" data-id="element-990">92%</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-2" data-id="element-991">
                <div className="bg-emerald-500 h-2 rounded-full" style={{
                width: '92%'
              }} data-id="element-992"></div>
              </div>
            </div>
            <div data-id="element-993">
              <div className="flex justify-between mb-2" data-id="element-994">
                <span className="text-sm text-blue-300" data-id="element-995">
                  Subscription Renewal
                </span>
                <span className="text-sm font-medium text-white" data-id="element-996">86%</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-2" data-id="element-997">
                <div className="bg-violet-500 h-2 rounded-full" style={{
                width: '86%'
              }} data-id="element-998"></div>
              </div>
            </div>
          </div>
        </DashboardCard>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-999">
        <DashboardCard title="Top Dealers" icon={<UsersIcon size={20} className="text-blue-400" data-id="element-1001" />} data-id="element-1000">
          <div className="space-y-4" data-id="element-1002">
            {['TEXAS INTERNATIONAL IRRIGATION', 'UWR', 'I-BEAM Irrigation', 'AQUADOC', 'NORTHERN IRRIGATION SYSTEMS'].map((dealer, index) => <div key={index} className="flex items-center" data-id="element-1003">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center mr-3" data-id="element-1004">
                  <span className="text-white text-xs font-bold" data-id="element-1005">
                    {dealer.split(' ').map(word => word[0]).join('')}
                  </span>
                </div>
                <div className="flex-1" data-id="element-1006">
                  <div className="text-sm font-medium text-white" data-id="element-1007">{dealer}</div>
                  <div className="flex items-center mt-1" data-id="element-1008">
                    <div className="w-full bg-slate-700/50 rounded-full h-1.5" data-id="element-1009">
                      <div className="bg-blue-500 h-1.5 rounded-full" style={{
                    width: `${100 - index * 10}%`
                  }} data-id="element-1010"></div>
                    </div>
                    <span className="ml-2 text-xs text-blue-300" data-id="element-1011">
                      {167 - index * 15}
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </DashboardCard>
        <DashboardCard title="Recent Activity" icon={<TrendingUpIcon size={20} className="text-blue-400" data-id="element-1013" />} data-id="element-1012">
          <div className="space-y-4" data-id="element-1014">
            <ActivityItem title="New order received" description="Order #HX6AA6-3 from AGRICULTURAL SERVICES Inc" time="2 hours ago" icon={<TruckIcon size={16} className="text-indigo-400" data-id="element-1016" />} iconBg="bg-indigo-500/20" data-id="element-1015" />
            <ActivityItem title="Quote approved" description="Quote #DKEYFH-1 for $64,699.26" time="5 hours ago" icon={<CheckCircleIcon size={16} className="text-emerald-400" data-id="element-1018" />} iconBg="bg-emerald-500/20" data-id="element-1017" />
            <ActivityItem title="Warranty claim rejected" description="Claim #WC-2023-089 for missing parts" time="Yesterday" icon={<XCircleIcon size={16} className="text-rose-400" data-id="element-1020" />} iconBg="bg-rose-500/20" data-id="element-1019" />
            <ActivityItem title="New subscription activated" description="iCRcell subscription for VK SALES & SERVICE" time="2 days ago" icon={<BadgeIcon size={16} className="text-violet-400" data-id="element-1022" />} iconBg="bg-violet-500/20" data-id="element-1021" />
            <ActivityItem title="Quote converted to order" description="Quote #ZAK096-2 for $189,847.68" time="3 days ago" icon={<DollarSignIcon size={16} className="text-blue-400" data-id="element-1024" />} iconBg="bg-blue-500/20" data-id="element-1023" />
          </div>
        </DashboardCard>
        <DashboardCard title="Issue Analysis" icon={<ClipboardCheckIcon size={20} className="text-blue-400" data-id="element-1026" />} data-id="element-1025">
          <div className="space-y-4" data-id="element-1027">
            <div className="flex items-center justify-between mb-2" data-id="element-1028">
              <h3 className="text-sm font-medium text-blue-300" data-id="element-1029">Top Issues</h3>
              <button className="text-blue-400 hover:text-white" data-id="element-1030">
                <MoreHorizontalIcon size={16} data-id="element-1031" />
              </button>
            </div>
            <IssueItem name="Leaks and Seal Damage" count={40} percentage={40} color="blue" data-id="element-1032" />
            <IssueItem name="Electrical Components" count={18} percentage={18} color="amber" data-id="element-1033" />
            <IssueItem name="Wheel and Tire Issues" count={30} percentage={30} color="red" data-id="element-1034" />
            <IssueItem name="Engine Failures" count={25} percentage={25} color="rose" data-id="element-1035" />
            <IssueItem name="Structure Issues" count={30} percentage={30} color="emerald" data-id="element-1036" />
            <IssueItem name="Manufacturing Defects" count={35} percentage={35} color="indigo" data-id="element-1037" />
          </div>
        </DashboardCard>
      </div>
    </div>;
}
function StatCard({
  title,
  value,
  trend,
  trendLabel,
  trendUp,
  icon,
  color
}) {
  const colors = {
    blue: 'from-blue-500/20 to-blue-600/20 border-blue-500/30',
    indigo: 'from-indigo-500/20 to-indigo-600/20 border-indigo-500/30',
    emerald: 'from-emerald-500/20 to-emerald-600/20 border-emerald-500/30',
    violet: 'from-violet-500/20 to-violet-600/20 border-violet-500/30'
  };
  return <div className={`bg-gradient-to-br ${colors[color]} border rounded-xl p-5`} data-id="element-1038">
      <div className="flex justify-between items-start mb-4" data-id="element-1039">
        <div className="p-2 rounded-lg bg-slate-800/50" data-id="element-1040">{icon}</div>
        <div className={`flex items-center px-2 py-1 rounded-full text-xs font-medium ${trendUp ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'}`} data-id="element-1041">
          {trendUp ? <ArrowUpIcon size={12} className="mr-1" data-id="element-1042" /> : <ArrowDownIcon size={12} className="mr-1" data-id="element-1043" />}
          {trend}
        </div>
      </div>
      <div className="text-2xl font-bold text-white mb-1" data-id="element-1044">{value}</div>
      <div className="text-sm text-blue-300" data-id="element-1045">{title}</div>
      <div className="mt-3 text-xs text-blue-400" data-id="element-1046">{trendLabel}</div>
    </div>;
}
function RegionStat({
  name,
  value,
  percentage,
  color
}) {
  const colors = {
    blue: 'bg-blue-500',
    indigo: 'bg-indigo-500',
    emerald: 'bg-emerald-500',
    amber: 'bg-amber-500',
    rose: 'bg-rose-500',
    violet: 'bg-violet-500'
  };
  return <div className="bg-slate-800/70 rounded-lg p-3" data-id="element-1047">
      <div className="flex justify-between items-center mb-2" data-id="element-1048">
        <span className="text-sm font-medium text-white" data-id="element-1049">{name}</span>
        <span className="text-sm text-blue-300" data-id="element-1050">{value}</span>
      </div>
      <div className="w-full bg-slate-700 rounded-full h-1.5" data-id="element-1051">
        <div className={`${colors[color]} h-1.5 rounded-full`} style={{
        width: `${percentage}%`
      }} data-id="element-1052"></div>
      </div>
    </div>;
}
function ActivityItem({
  title,
  description,
  time,
  icon,
  iconBg
}) {
  return <div className="flex" data-id="element-1053">
      <div className={`w-8 h-8 rounded-full ${iconBg} flex items-center justify-center mr-3 flex-shrink-0`} data-id="element-1054">
        {icon}
      </div>
      <div data-id="element-1055">
        <div className="text-sm font-medium text-white" data-id="element-1056">{title}</div>
        <div className="text-xs text-blue-300" data-id="element-1057">{description}</div>
        <div className="text-xs text-slate-400 mt-1" data-id="element-1058">{time}</div>
      </div>
    </div>;
}
function IssueItem({
  name,
  count,
  percentage,
  color
}) {
  const colors = {
    blue: 'bg-blue-500',
    indigo: 'bg-indigo-500',
    emerald: 'bg-emerald-500',
    amber: 'bg-amber-500',
    red: 'bg-red-500',
    rose: 'bg-rose-500'
  };
  return <div data-id="element-1059">
      <div className="flex justify-between mb-1" data-id="element-1060">
        <span className="text-xs text-blue-300" data-id="element-1061">{name}</span>
        <span className="text-xs font-medium text-white" data-id="element-1062">{count}</span>
      </div>
      <div className="w-full bg-slate-700/50 rounded-full h-1.5" data-id="element-1063">
        <div className={`${colors[color]} h-1.5 rounded-full`} style={{
        width: `${percentage}%`
      }} data-id="element-1064"></div>
      </div>
    </div>;
}